export enum ReminderType {
  Email = 'Email',
  Sms = 'SMS',
}
